import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Autocomplete,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  createAsset,
  deleteAsset,
  getAssets,
  updateAsset,
  getCategoryList,
  createAssetAssign,
} from "../../api/asset";
import { getEmployeesList } from "../../api/employee";
import { handleAxiosError } from "../../config/action-config";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { assetTable as tableDef } from "../../config/grid-columns-defs";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import UpdateDialog from "../../component/UpdateDialog";
import CreateDialog from "../../component/CreateDialog";
import { showAlert } from "../../actions/alert";
import { Controller, useForm } from "react-hook-form";
import BetterControlledTable from "../../component/BetterControlledTable";
import AddEmployeeToAssetDialog from "../../component/AddEmployeeToAsset";
import { Visibility } from "@mui/icons-material";

const emptyUpdateData = {
  asset_id: "",
  assigned_emp_id: "",
  category_id: "",
  description: "",
  purchasedate: "",
  warrantyrenewalcost: "",
  location: "",
  warrantyexpirationdate: "",
  serialnumber: "",
  unitcost: "",
};

const emptyNewAssetData = {
  asset_id: "",
  assigned_emp_id: "",
  category_id: "",
  description: "",
  purchasedate: "",
  warrantyrenewalcost: "",
  location: "",
  warrantyexpirationdate: "",
  serialnumber: "",
  unitcost: "",
};

export default function Asset() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [assetDialogOpen, setAssetDialogOpen] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [updateDialogOpen, setUpdateDialogeOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const [updateId, setUpdateId] = useState(-1);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [updateData, setUpdateData] = useState(emptyUpdateData);
  const [operatingSystemValue, setOperatingSystemValue] = useState("");
  const [ramValue, setRamValue] = useState("");
  const [assetId, setAssetId] = useState("");
  const [storageValue, setStorageValue] = useState("");
  let obj = tableDef.find((o) => o.headerName === "Assign");
  const [newAssetData, setNewAssetData] = useState(emptyNewAssetData);
  addAdditionalColumn(obj, dispatch, setAssetId);
  const onNewAssetSubmit = (newAssetData) => {
    const combineData = { ...newAssetData, status: "AVAILABLE" };
    createAsset(combineData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setNewAssetData(emptyNewAssetData);
        refreshTable();
        setCreateDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setCreateDialogOpen(false);
      });
  };
  const onNewAssetAssignSubmit = (newAssetData) => {
    const combineData = { ...newAssetData, asset_id: assetId };
    createAssetAssign(combineData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setNewAssetData(emptyNewAssetData);
        refreshTable();
        setAssetDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setCreateDialogOpen(false);
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "EDIT": {
        setUpdateDialogeOpen(true);
        const up = getUpdatableData(dialogAction.data);
        setUpdateData(up);
        break;
      }
      case "DELETE":
        setDeleteDialogOpen(true);
        break;
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      case "ASSETDAILOG":
        dispatch({ type: "" });
        setAssetDialogOpen(true);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (deleteId === -1) return;
    deleteAsset(deleteId, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);

  useEffect(() => {
    if (updateId === -1) return;
    updateAsset(updateId, updateData, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setUpdateId(-1);
        setUpdateData(emptyUpdateData);
        refreshTable();
        setUpdateDialogeOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setUpdateId(-1);
        setUpdateDialogeOpen(false);
      });
  }, [updateId]);

  const changeUpdateData = (e) => {
    setUpdateData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    if (!createDialogOpen) {
      setNewAssetData(emptyNewAssetData);
    }
  }, [createDialogOpen]);

  const [assetTableRefreshCount, setAssetTableRefreshCount] = useState(0);
  async function getAssetTableData(limit, offset) {
    try {
      const { data } = await getAssets({ limit, offset }, user.token);

      return {
        rows: data.assetdetails,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  function refreshTable(e) {
    e?.preventDefault();
    setAssetTableRefreshCount((prev) => prev + 1);
  }

  useEffect(() => {
    employeeList();
    categoryAssetList();
  }, []);

  const employeeList = async () => {
    const token = user.token;
    return await getEmployeesList(
      { employment_status: "Current-Employee" },
      token
    )
      .then((res) => {
        setEmployeesList(res.data.data);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const categoryAssetList = async () => {
    const token = user.token;
    return await getCategoryList({ name: "" }, token)
      .then((res) => {
        setCategoryList(res.data.categories);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };
  const operatingSystemOptions = [
    { label: "Windows" },
    { label: "MacOS" },
    { label: "Linux" },
  ];
  const ramOptions = [
    { label: "2 GB" },
    { label: "4 GB" },
    { label: "6 GB" },
    { label: "8 GB" },
    { label: "16 GB" },
    { label: "32 GB" },
  ];
  const storageOptions = [
    { label: "500 GB" },
    { label: "1 TB" },
    { label: "2 TB" },
  ];
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Assets
          </Typography>
        </Box>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="blue-button"
        >
          Add Asset
        </Button>
      </Box>

      <br />
      <div className="pmt-controll-table">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getAssetTableData}
          columns={tableDef}
          perPage={10}
          refreshCounter={assetTableRefreshCount}
          onCellClicked={(params) => {
            setAssetId(params?.data?.id);
          }}
        />
      </div>
      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />
      <UpdateDialog
        open={updateDialogOpen}
        setOpen={setUpdateDialogeOpen}
        setUpdateId={setUpdateId}
        rowId={dialogAction.data?.id}
      >
        <Grid container spacing={2}>
          {/* <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="asset_id"
              fullWidth
              value={updateData.asset_id}
              onChange={changeUpdateData}
              label="Asset Id"
              type="number"
              variant="outlined"
            />
          </Grid> */}

          <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl fullWidth style={{ marginTop: "10px" }}>
              <InputLabel id="demo-simple-select-label">Assigned To</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="assigned_emp_id"
                id="demo-simple-select"
                value={updateData.assigned_emp_id}
                onChange={changeUpdateData}
                label="Reporting Manager"
              >
                <MenuItem value="">Select</MenuItem>
                {employeesList.map((e, i) => (
                  <MenuItem key={i} value={e.id}>
                    {e.firstname}
                  </MenuItem>
                ))}
                <MenuItem value="None">None</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl fullWidth style={{ marginTop: "10px" }}>
              <InputLabel id="demo-simple-select-label">Category</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="category_id"
                id="demo-simple-select"
                value={updateData.category_id}
                onChange={changeUpdateData}
                label="Category"
              >
                <MenuItem value="">Select</MenuItem>
                {categoryList.map((e, i) => (
                  <MenuItem key={i} value={e.id}>
                    {e.category}
                  </MenuItem>
                ))}
                <MenuItem value="None">None</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="description"
              fullWidth
              value={updateData.description}
              onChange={changeUpdateData}
              label="Description"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                size="small"
                inputFormat="MM/dd/yyyy"
                label="Purchase Date"
                value={updateData.purchasedate}
                disabled={true}
                onChange={() => {}}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="warrantyrenewalcost"
              fullWidth
              value={updateData.warrantyrenewalcost}
              onChange={changeUpdateData}
              label="Warranty Renewal Cost"
              type="number"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="location"
              fullWidth
              value={updateData.location}
              onChange={changeUpdateData}
              label="Location"
              type="text"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                size="small"
                inputFormat="MM/dd/yyyy"
                label="Warranty Expiration Date"
                value={updateData.warrantyexpirationdate}
                disabled={true}
                onChange={() => {}}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="serialnumber"
              fullWidth
              value={updateData.serialnumber}
              onChange={changeUpdateData}
              label="Serial Number"
              type="number"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              margin="dense"
              name="unitcost"
              fullWidth
              value={updateData.unitcost}
              onChange={changeUpdateData}
              label="Unit Cost"
              type="number"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </UpdateDialog>
      <CreateDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onSubmit={handleSubmit(onNewAssetSubmit)}
      >
        <Grid container spacing={2}>
          {/* <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="asset_id"
              fullWidth
              label="Asset Id"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Asset id is required.",
              })}
              required
              error={Boolean(errors.asset_id)}
              helperText={errors.asset_id?.message}
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              margin="dense"
              name="item_name"
              fullWidth
              label="Asset Name"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Asset name is required.",
              })}
              required
              error={Boolean(errors.item_name)}
              helperText={errors.item_name?.message}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <FormControl
              margin="dense"
              fullWidth
              required
              error={Boolean(errors.category_id)}
            >
              <InputLabel id="demo-simple-select-label">Category</InputLabel>
              <Controller
                render={(props) => (
                  <Select
                    MenuProps={{ className: "select-box-height" }}
                    value={props.value}
                    label="Category"
                    onChange={(e) => {
                      props.onChange(e);
                      handleCategoryChange(e);
                    }}
                  >
                    {categoryList.map((e, i) => (
                      <MenuItem key={i} value={e.id}>
                        {e.category}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                name="category_id"
                control={control}
                // defaultValue=""
                rules={{
                  required: "Please select Category.",
                }}
              />
              <FormHelperText>{errors.category_id?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              name="description"
              fullWidth
              label="Description"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Description is required.",
              })}
              required
              error={Boolean(errors.description)}
              helperText={errors.description?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl fullWidth error={Boolean(errors.purchasedate)}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  render={(props) => (
                    <DesktopDatePicker
                      label="Purchased Date"
                      value={props.value || ""}
                      onChange={(newValue) => props.onChange(newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(errors.purchasedate)}
                        />
                      )}
                    />
                  )}
                  name="purchasedate"
                  control={control}
                />
              </LocalizationProvider>
              {errors.purchasedate && (
                <FormHelperText error>
                  {errors.purchasedate.message}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              name="manufacturer"
              fullWidth
              label="Manufacturer"
              type="text"
              variant="outlined"
              inputRef={register}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              name="model"
              fullWidth
              label="Model"
              type="text"
              variant="outlined"
              inputRef={register}
            />
          </Grid>
          {selectedCategory === 1 && (
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="macaddress"
                fullWidth
                label="MAC Address"
                type="text"
                variant="outlined"
                inputRef={register}
              />
            </Grid>
          )}
          {selectedCategory === 4 && (
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="imei"
                fullWidth
                label="IMEI"
                type="text"
                variant="outlined"
                inputRef={register}
              />
            </Grid>
          )}
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="cpu"
                fullWidth
                label="CPU"
                type="text"
                variant="outlined"
                inputRef={register}
              />
            </Grid>
          )}
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={6}>
              <Autocomplete
                value={
                  operatingSystemOptions.find(
                    (option) => option.label === operatingSystemValue
                  ) || operatingSystemValue
                }
                inputValue={operatingSystemValue}
                onInputChange={(event, newInputValue) => {
                  setOperatingSystemValue(newInputValue);
                }}
                options={operatingSystemOptions.map((option) => option.label)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="operatingsystem"
                    fullWidth
                    label="Operating System"
                    variant="outlined"
                    inputRef={register}
                  />
                )}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              name="location"
              fullWidth
              label="Location"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Location is required.",
              })}
              required
              error={Boolean(errors.location)}
              helperText={errors.location?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl
              fullWidth
              error={Boolean(errors.warrantyexpirationdate)}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  render={(props) => (
                    <DesktopDatePicker
                      label="Warranty Expiration Date"
                      value={props.value || ""}
                      onChange={(newValue) => props.onChange(newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(errors.warrantyexpirationdate)}
                        />
                      )}
                    />
                  )}
                  name="warrantyexpirationdate"
                  control={control}
                />
              </LocalizationProvider>
              {errors.warrantyexpirationdate && (
                <FormHelperText error>
                  {errors.warrantyexpirationdate.message}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          {(selectedCategory === 1 ||
            selectedCategory === 4 ||
            selectedCategory === 5) && (
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="serialnumber"
                fullWidth
                label="Serial Number"
                variant="outlined"
                inputRef={register({
                  required: "Serial number is required.",
                })}
                required
                error={Boolean(errors.serialnumber)}
                helperText={errors.serialnumber?.message}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              name="unitcost"
              fullWidth
              label="Unit Cost($)"
              type="number"
              variant="outlined"
              inputRef={register({
                required: "Unit cost is required.",
              })}
              required
              error={Boolean(errors.unitcost)}
              helperText={errors.unitcost?.message}
            />
          </Grid>
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={6}>
              <Autocomplete
                value={
                  ramOptions.find((option) => option.label === ramValue) ||
                  ramValue
                }
                inputValue={ramValue}
                onInputChange={(event, newInputValue) => {
                  setRamValue(newInputValue);
                }}
                options={ramOptions.map((option) => option.label)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="ram"
                    fullWidth
                    label="RAM"
                    variant="outlined"
                    inputRef={register}
                  />
                )}
              />
            </Grid>
          )}
          {(selectedCategory === 1 || selectedCategory === 4) && (
            <Grid item xs={12} sm={6} md={6}>
              <Autocomplete
                value={
                  storageOptions.find(
                    (option) => option.label === storageValue
                  ) || storageValue
                }
                inputValue={storageValue}
                onInputChange={(event, newInputValue) => {
                  setStorageValue(newInputValue);
                }}
                options={storageOptions.map((option) => option.label)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="storage"
                    fullWidth
                    label="Storage"
                    variant="outlined"
                    inputRef={register}
                  />
                )}
              />
            </Grid>
          )}
          {/* <Grid item xs={12} sm={6} md={6}>
            <input
              accept="image/*"
              id="assetimage"
              type="file"
              onChange={(e) => {
                setNewAssetData((prev) => ({
                  ...prev,
                  assetimage: e.target.files[0],
                }));
              }}
              style={{ display: "none" }}
            />
            <label htmlFor="assetimage">
              <Button
                variant="contained"
                component="span"
                className="blue-button"
              >
                Upload Asset Image
              </Button>
            </label>
          </Grid> */}
        </Grid>
      </CreateDialog>
      <AddEmployeeToAssetDialog
        open={assetDialogOpen}
        setOpen={setAssetDialogOpen}
        onSubmit={handleSubmit(onNewAssetAssignSubmit)}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl
              margin="dense"
              fullWidth
              error={Boolean(errors.assigned_date)}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  render={(props) => (
                    <DesktopDatePicker
                      label="Assigned Date"
                      value={props.value || Date()}
                      onChange={(newValue) => props.onChange(newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(errors.assigned_date)}
                        />
                      )}
                    />
                  )}
                  name="assigned_date"
                  control={control}
                />
              </LocalizationProvider>
              {errors.assigned_date && (
                <FormHelperText error>
                  {errors.assigned_date.message}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl
              fullWidth
              required
              error={Boolean(errors.assigned_emp_id)}
            >
              <InputLabel id="demo-simple-select-label">Assigned To</InputLabel>
              <Controller
                render={(props) => (
                  <Select
                    MenuProps={{ className: "select-box-height" }}
                    value={props.value}
                    label="Assigned To"
                    onChange={(e) => {
                      props.onChange(e);
                    }}
                  >
                    {employeesList.map((e, i) => (
                      <MenuItem key={i} value={e.id}>
                        {e.firstname}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                name="assigned_emp_id"
                control={control}
                // defaultValue=""
                rules={{
                  required: "Please select Assigned to.",
                }}
              />
              <FormHelperText>{errors.assigned_emp_id?.message}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </AddEmployeeToAssetDialog>
    </Box>
  );
}
function addAdditionalColumn(obj, dispatch, setAssetId) {
  if (obj === undefined) {
    tableDef.unshift(
      {
        headerName: "Assign",
        field: "assigns",
        resizable: true,
        wrapText: true,
        autoHeight: true,
        // minWidth: 150,
        minWidth: 120,
        headerClass: "justify-center",
        cellClass: "justify-center",
        cellRendererFramework: (params) => (
          <>
            {params?.data?.status === "AVAILABLE" ? (
              <Button
                sx={{ height: "20px", mr: 1 }}
                className="blue-button"
                onClick={() => {
                  setAssetId(params.data.id);
                  dispatch({ type: "ASSETDAILOG", data: params.data });
                }}
              >
                Assign
              </Button>
            ) : (
              <Button
                sx={{ height: "20px", mr: 1 }}
                // className="blue-button"
                onClick={() => {
                  dispatch({ type: "VIEW", data: params.data });
                }}
              >
                {params?.data?.status}
              </Button>
            )}
          </>
        ),
      },
      {
        headerName: "Action",
        field: "actions",
        resizable: true,
        wrapText: true,
        autoHeight: true,
        // minWidth: 150,
        minWidth: 90,
        headerClass: "justify-center",
        cellClass: "justify-center",
        cellRendererFramework: (params) => (
          <>
            <IconButton
              color="info"
              onClick={() => {
                dispatch({ type: "VIEW", data: params.data });
              }}
              sx={{ height: "20px", px: 1 }}
              variant="outlined"
            >
              <VisibilityIcon fontSize="inherit" />
            </IconButton>
          </>
        ),
      }
    );
  }
}
function getUpdatableData(data) {
  return {
    asset_id: data.asset_id,
    assigned_emp_id: data.assigned_emp_id,
    category_id: data.category_id,
    description: data.description,
    purchasedate: data.purchasedate,
    warrantyrenewalcost: data.warrantyrenewalcost,
    location: data.location,
    warrantyexpirationdate: data.warrantyexpirationdate,
    serialnumber: data.serialnumber,
    unitcost: data.unitcost,
  };
}

function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
